module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-blue-dark p-4 pb-8 flex items-center mb-4"
  }, [_c('img', {
    staticClass: "rounded-full w-10 h-10 mr-4 shadow-lg",
    attrs: {
      "src": _vm.$store.state.user.gravatar,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-col"
  }, [_c('h4', {
    staticClass: "text-white tracking-wide"
  }, [_vm._v(_vm._s(_vm.$store.state.user.name))]), _vm._v(" "), _c('div', {
    staticClass: "text-right text-xxs text-white"
  }, [_vm._v("Logout")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ad7e2c9","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/sidemenu/LoggedUserSection.vue
// module id = 603
// module chunks = 66